//Created on behalf https://github.com/Frank13
//Modified on behalf Roeland Verbakel
import { surveyLocalization } from "../surveyStrings";

export var dutchSurveyStrings = {
  pagePrevText: "Vorige",
  pageNextText: "Volgende",
  completeText: "Verzenden",
  startSurveyText: "Start",
  otherItemText: "Anders, nl.",
  noneItemText: "Geen",
  selectAllItemText: "Selecteer Alles",
  progressText: "Pagina {0} van {1}",
  panelDynamicProgressText: "Record {0} of {1}",
  questionsProgressText: "Geantwoord {0}/{1} vragen",
  emptySurvey: "Er is geen zichtbare pagina of vraag in deze vragenlijst",
  completingSurvey: "Bedankt voor het invullen van de vragenlijst",
  completingSurveyBefore:
      "Onze gegevens tonen aan dat je deze vragenlijst reeds beantwoord hebt.",
  loadingSurvey: "De vragenlijst is aan het laden...",
  optionsCaption: "Kies...",
  value: "waarde",
  requiredError: "Dit is een vereiste vraag",
  requiredErrorInPanel: "Gelieve ten minste een vraag te beantwoorden.",
  numericError: "Het antwoord moet een getal zijn",
  textMinLength: "Vul minstens {0} karakters in",
  minSelectError: "Selecteer minimum {0} antwoorden",
  maxSelectError: "Selecteer niet meer dan {0} antwoorden",
  textMaxLength: "Gelieve minder dan {0} karakters in te vullen.",
  textMinMaxLength: "Gelieve meer dan {0} en minder dan {1} karakters in te vullen.",
  minRowCountError: "Gelieve ten minste {0} rijen in te vullen.",
  numericMinMax:
      "Uw antwoord '{0}' moet groter of gelijk zijn aan {1} en kleiner of gelijk aan {2}",
  numericMin: "Uw antwoord '{0}' moet groter of gelijk zijn aan {1}",
  numericMax: "Uw antwoord '{0}' moet groter of gelijk zijn aan {1}",
  invalidEmail: "Vul een geldig e-mailadres in",
  invalidExpression: "De uitdrukking: {0} moet 'waar' teruggeven.",
  urlRequestError: "De vraag keerde een fout terug '{0}'. {1}",
  urlGetChoicesError:
      "De vraag gaf een leeg antwoord terug of de 'pad' eigenschap is niet correct",
  exceedMaxSize: "De grootte van het bestand mag niet groter zijn dan {0}",
  otherRequiredError: "Vul het veld 'Anders, nl.' in",
  requiredInAllRowsError: "Deze vraag vereist één antwoord per rij",
  uploadingFile:
      "Uw bestand wordt opgeladen. Gelieve enkele seconden te wachten en opnieuw te proberen.",
  loadingFile: "Opladen...",
  chooseFile: "Kies uw bestand(en)...",
  noFileChosen: "Geen bestand gekozen",
  confirmDelete: "Wil je deze gegevens verwijderen?",
  keyDuplicationError: "Deze waarde moet uniek zijn.",
  addColumn: "Voeg kolom toe",
  addRow: "Voeg rij toe",
  removeRow: "Verwijder",
  addPanel: "Nieuwe toevoegen",
  removePanel: "Verwijder",
  choices_Item: "onderwerp",
  matrix_column: "Kolom",
  matrix_row: "Rij",
  savingData: "De resultaten worden bewaard op de server...",
  savingDataError: "Er was een probleem en we konden de resultaten niet bewaren.",
  savingDataSuccess: "De resultaten werden succesvol bewaard!",
  saveAgainButton: "Probeer opnieuw",
  timerMin: "minimum",
  timerSec: "sec",
  timerSpentAll: "U heeft {0} gespendeerd op deze pagina en {1} in totaal.",
  timerSpentPage: "U heeft {0} op deze pagina gespendeerd.",
  timerSpentSurvey: "U heeft in totaal {0} gespendeerd.",
  timerLimitAll:
      "U heeft {0} van {1} op deze pagina gespendeerd en {2} van {3} in totaal.",
  timerLimitPage: "U heeft {0} van {1} gespendeerd op deze pagina.",
  timerLimitSurvey: "U heeft {0} van {1} in het totaal.",
  cleanCaption: "Kuis op",
  clearCaption: "Kuis op",
  chooseFileCaption: "Gekozen bestand",
  removeFileCaption: "Verwijder deze file",
  booleanCheckedLabel: "Ja",
  booleanUncheckedLabel: "Neen",
  confirmRemoveFile: "Bent u zeker dat u deze file wilt verwijderen: {0}?",
  confirmRemoveAllFiles: "Bent u zeker dat u al deze files wilt verwijderen?"
};

surveyLocalization.locales["nl"] = dutchSurveyStrings;
surveyLocalization.localeNames["nl"] = "nederlands";


// WEBPACK FOOTER //
// ./src/localization/dutch.ts